import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

/** ************** 采购需求 ****************** */
// 分页查询采购需求列表
export function getDemandListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/demand-orders',
    method: 'get',
    params
  })
}

// 保存需求项目
export function storeDemandApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/demand-orders',
    method: 'post',
    data
  })
}

// 发布需求项目
export function releaseDemandApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/demand-orders/publish',
    method: 'post',
    data
  })
}

// 更新需求项目（在保存状态下继续保存）
export function updateDemandApi(orderId, data) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}`,
    method: 'put',
    data
  })
}

// 发布已保存的项目
export function releaseTemporaryDemandApi(orderId, data) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}/publish`,
    method: 'put',
    data
  })
}

// 导入Excel表格
export function importExcelDemandApi(data) {
  return request(
    {
      url: baseUrl + `/workbench/template/demand-materiel/import`,
      method: 'post',
      data
    },
    true,
    true
  )
}

// 查询需求项目详情
export function getDemandDetailApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}`,
    method: 'get'
  })
}

// 删除已保存的项目
export function deleteDemandApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}`,
    method: 'delete'
  })
}

// 保存需求调查
export function storeDemandSurveyApi(orderId, data) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}/survey`,
    method: 'post',
    data
  })
}

// 发布需求调查
export function releaseDemandSurveyApi(orderId, data) {
  return request({
    url:
      baseUrl + `/workbench/purchaser/demand-orders/${orderId}/survey/publish`,
    method: 'post',
    data
  })
}

// 查询需求调查信息
export function getDemandSurveyMesApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}/survey`,
    method: 'get'
  })
}
// 查询需求调查信息中（咨询/论证方式下）的人员列表
export function getDemandSurveyStaffMesApi(orderId, surveyId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/demand-orders/${orderId}/survey/${surveyId}/consulters`,
    method: 'get'
  })
}
// 查询需求调查信息中（线上调查模板）
export function getOnlineSurveyMesApi(orderId, surveyId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/demand-orders/${orderId}/survey/${surveyId}/online-template`,
    method: 'get'
  })
}

// 获取报名响应的供应商列表
export function getSupplierSignUpListApi(orderId, params) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}/trades/page`,
    method: 'get',
    params
  })
}

// 获取供应商报名信息
export function getSupplierSignUpInfoApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/demand-orders/${orderId}/trades/${tradeId}/sign-up`,
    method: 'get'
  })
}

// 对报名供应商进行审核
export function auditSupplierInfoApi(orderId, tradeId, data) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/demand-orders/${orderId}/trades/${tradeId}/sign-up/approval`,
    method: 'put',
    data
  })
}

// 供应商报名审核记录
export function getAuditRecordListApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/demand-orders/${orderId}/trades/${tradeId}/sign-up/approvals`,
    method: 'get'
  })
}

// 查看报名供应商的响应信息
export function getSupplierResponseInfoApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/demand-orders/${orderId}/trades/${tradeId}/apply`,
    method: 'get'
  })
}

// 保存需求录入信息
export function storeDemandEntryInfoApi(orderId, data) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}/input`,
    method: 'post',
    data
  })
}

// 发布需求录入信息
export function releaseDemandEntryInfoApi(orderId, data) {
  return request({
    url:
      baseUrl + `/workbench/purchaser/demand-orders/${orderId}/input/publish`,
    method: 'post',
    data
  })
}

// 获取需求录入信息
export function getDemandEntryInfoApi(orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-orders/${orderId}/input`,
    method: 'get'
  })
}

// 查询采购需求项目详情
export function getDemandProjectDetailApi(orderId) {
  return request({
    url: baseUrl + `/monitor/project/demand-orders/${orderId}/detail`,
    method: 'get'
  })
}

// 查询采购需求项目详情
export function getDemandPConsulterListApi(orderId, surveyId) {
  return request({
    url:
      baseUrl +
      `/monitor/project/demand-orders/${orderId}/survey/${surveyId}/consulters`,
    method: 'get'
  })
}

// 主动上传成果文件
export function uploadDemandResultFileApi(orderId, documentId) {
  return request({
    url:
      baseUrl +
      `/monitor/project/demand-orders/${orderId}/document/${documentId}/upload-document`,
    method: 'put'
  })
}

/** ***********实施计划************ */

// 分页查询采购实施计划列表
export function getDemandPlanOrderListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/demand-plans',
    method: 'get',
    params
  })
}

// 查询实施计划详情
export function getDemandPlanOrderDetailApi(params) {
  return request({
    url: baseUrl + `/monitor/project/demand-plans/${params.planId}/detail`,
    method: 'get'
  })
}

// 保存实施计划
export function addDemandPlanOrderApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/demand-plans',
    method: 'post',
    data
  })
}

// 更新实施计划
export function updateDemandPlanOrderApi(data) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-plans/${data.planId}`,
    method: 'put',
    data
  })
}

// 发布实施计划
export function publishDemandPlanOrderApi(data) {
  return request({
    url: baseUrl + '/workbench/purchaser/demand-plans/publish',
    method: 'post',
    data
  })
}

// 编辑后发布实施计划
export function publishSavedDemandPlanOrderApi(data) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-plans/${data.planId}/publish`,
    method: 'put',
    data
  })
}

// 删除实施计划
export function deleteDemandPlanOrderApi(params) {
  return request({
    url: baseUrl + `/workbench/purchaser/demand-plans/${params.planId}`,
    method: 'delete'
  })
}

// 主动上传成果文件
// export function uploadPlanResultFileApi(planId, documentId) {
//   return request({
//     url:
//       baseUrl +
//       `/monitor/project/demand-plans/${planId}/document/${documentId}/upload-document`,
//     method: 'put'
//   })
// }

// 主动上传成果文件（v2）（上传文件id）
export function uploadPlanResultFileApi(planId, documentId, params) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/demand-plans/${planId}/document/${documentId}/upload-attachment`,
    method: 'put',
    params
  })
}

/** *****成果******** */

// 分页查询采购实施计划列表
export function getResultFileListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/demand-documents',
    method: 'get',
    params
  })
}
